<div class="card" [class.elevated]="elevated">

    <div class="card-image" style="background-image: url('{{ image }}')"></div>

    <div class="card-header" *ngIf="title">
        <h3 class="card-title">{{ title }}</h3>
    </div>

    <div class="card-footer" *ngIf="footer">
        <div class="lines">
            {{ footer }}
        </div>
    </div>

</div>
